import React from 'react';
import useI18n from 'hooks/I18n/useI18n.js';
import { getLocaleConfig } from 'modules/config/i18n';

const MapFooter = () => {
    const { i18n, i18nConfig, trans } = useI18n();
    const localeConf = getLocaleConfig(i18n);
    const localeForLink = localeConf.shortcut ? localeConf.shortcut : localeConf.code;

    return (
        <div className="pi-map-termsFooter">
            <a
                href={`/${localeForLink}/p/legal-mentions`}
                target="_blank"
                title={trans('publicFooter.links.legal')}
                aria-label={trans('publicFooter.links.legal')}
            >
                {trans('publicFooter.links.legal')}
            </a>
            <a
                href={`/${localeForLink}/p/terms`}
                target="_blank"
                title={trans('publicFooter.links.terms')}
                aria-label={trans('publicFooter.links.terms')}
            >
                {trans('publicFooter.links.terms')}
            </a>
            <a
                href={trans('privacy_policy_link')}
                target="_blank"
                title={trans('footer_privacy_policy')}
                aria-label={trans('footer_privacy_policy')}
            >
                {trans('footer_privacy_policy')}
            </a>
            {i18nConfig?.links?.ourDatas && (
                <a
                    href={i18nConfig.links.ourDatas}
                    target="_blank"
                    title={trans('publicFooter.links.data')}
                    aria-label={trans('publicFooter.links.data')}
                >
                    {trans('publicFooter.links.data')}
                </a>
            )}
            <a
                href="https://www.mapbox.com/about/maps/"
                target="_blank"
                title="Mapbox"
                aria-label="Mapbox"
            >
                © Mapbox
            </a>
            <a
                href="https://www.openstreetmap.org/about/"
                target="_blank"
                title="OpenStreetMap"
                aria-label="OpenStreetMap"
            >
                © OpenStreetMap
            </a>
        </div>
    );
};

export default MapFooter;
